// PLUGINS IMPORTS //
import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import dayjs from 'dayjs'

// COMPONENTS IMPORTS //
import { memoComparison } from 'Content/Shared/Helpers/Functions/Functions'

// EXTRA IMPORTS //

// REDUX //
import { BlogType, BlogColors } from 'Redux/Types/BlogsTypes'

/////////////////////////////////////////////////////////////////////////////

interface PropsType {
  data: BlogType
}

const BlogItem: React.FC<PropsType> = ({ data }) => {
  const preText =
    data.paragraphs[0] && data.paragraphs[0].text ? data.paragraphs[0].text : ''

  const numOfCoffess = data.timeToRead / 10

  return (
    <Link to={`/blog/${data.id}`} style={{ width: '100%' }}>
      <Wrapper>
        <Title>{data.title}</Title>

        <Row>
          <Subnote>
            {dayjs(data.date).format('DD')} {dayjs(data.date).format('MMMM')} of{' '}
            {dayjs(data.date).format('YYYY')} •{' '}
          </Subnote>
          <Subnote>
            <span style={{ marginRight: '10px' }}>
              {'☕️'.repeat(numOfCoffess)}
            </span>
            {data.timeToRead} min read
          </Subnote>
        </Row>
        <TagWrapper
          color={BlogColors[data.tag] ? BlogColors[data.tag] : '#fff'}
        >
          {data.tag}
        </TagWrapper>
      </Wrapper>
    </Link>
  )
}

/////////////////////////////////////////////////////////////////////////////

const Wrapper = styled.div`
  display: flex;
  width: 80%;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 46px;
`
const Title = styled.h1``

const Row = styled.div`
  margin-bottom: 14px;
  margin-top: -8px;
`

const Subnote = styled.span`
  margin-right: 2px;
  margin-left: 2px;
`
const TagWrapper = styled.div`
  border: 1px solid white;
  padding-right: 10px;
  padding-left: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 50px;
  background-color: ${(props) => props.color};
  color: black;
`

export default React.memo(BlogItem, memoComparison)
